const questions = [
    {
      questionText:
        "Do have any knowledge about how an incubation center works ?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText:
        "Have you ever contributed into a project sponsored by organization through incubation center?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText:
        "Do you think incubation center helps students for their ideas to grow and implement in real world projects?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText: "Which of the following is correct ?",
      answerOptions: [
        {
          answerText:
            "Incubators are useful in getting initial fundings for startups",
          isCorrect: false,
        },
        {
          answerText: "Incubators are used for getting mentorship for startups",
          isCorrect: false,
        },
        {
          answerText: "Both (A) and (B) are false",
          isCorrect: false,
        },
        {
          answerText: "Both (A) and (B) are true",
          isCorrect: true,
        },
      ],
    },
    {
      questionText: "Which are the entities involve in incubation center",
      answerOptions: [
        { answerText: "Student", isCorrect: false },
        { answerText: "Organization", isCorrect: false },
        { answerText: "University", isCorrect: false },
        { answerText: "All", isCorrect: true },
      ],
    },
    {
      questionText: "Have you ever contributed in real world projects ?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText:
        "Is team work and team co-operation important for an excellent project?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText: "Which is the most crucial part in a project ?",
      answerOptions: [
        { answerText: "Time Mangement", isCorrect: true },
        { answerText: "Finance Management", isCorrect: false },
        { answerText: "Team Work", isCorrect: true },
        { answerText: "Professional skills", isCorrect: false },
      ],
    },
    {
      questionText: "Most important qualities of a team mate?",
      answerOptions: [
        { answerText: "Reliable", isCorrect: false },
        { answerText: "Competitive", isCorrect: false },
        { answerText: "Supportive", isCorrect: true },
        { answerText: "Listerner", isCorrect: true },
      ],
    },
    {
      questionText: "How can a team leader fail?",
      answerOptions: [
        { answerText: "Poor time management", isCorrect: true },
        { answerText: "Lack of knowledge", isCorrect: true },
        { answerText: "Insufficent resources", isCorrect: false },
        { answerText: "Unreliable", isCorrect: false },
      ],
    },
    {
      questionText: "Programming language you are having knowledge of?",
      answerOptions: [
        { answerText: "C++,C", isCorrect: true },
        { answerText: "Java", isCorrect: false },
        { answerText: "Python", isCorrect: false },
        { answerText: "Javascrpit", isCorrect: true },
      ],
    },
    {
      questionText: "Frontend Development you are having practical knowledge of?",
      answerOptions: [
        { answerText: "React", isCorrect: true },
        { answerText: "Html", isCorrect: false },
        { answerText: "Tailwind", isCorrect: true },
        { answerText: "CSS", isCorrect: true },
      ],
    },
    {
      questionText: "Backend Development you are having knowledge of ?",
      answerOptions: [
        { answerText: "Node", isCorrect: true },
        { answerText: "Spring", isCorrect: false },
        { answerText: "Express", isCorrect: false },
        { answerText: "Nestjs", isCorrect: true },
      ],
    },
    {
      questionText: "Have you been certified in any programming language ?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
    {
      questionText:
        "According to you which is the most dynamic , efficient and advanced programming language ?",
      answerOptions: [
        { answerText: "Yes", isCorrect: true },
        { answerText: "No", isCorrect: false },
      ],
    },
  ];

  export default questions;